export default "__VITE_ASSET__BRc9JEkz__"